import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { InputWithErrorComponent } from '@nimmsta/ng-commons-lib/forms';
import { SoftwarePlatform } from '@nimmsta/ng-commons-lib/models';
import { SoftwareLabelFormComponent } from './software-label-form.component';
import { SoftwarePlatformService } from '../../services/software/software-platform.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-software-platform-form',
  templateUrl: './software-label-form.component.html',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    InputWithErrorComponent,
    ErrorComponent,
  ],
})
export class SoftwarePlatformFormComponent extends SoftwareLabelFormComponent {
  protected override dataService = inject(SoftwarePlatformService);

  constructor() {
    super();
    this.setValue(new SoftwarePlatform());
  }
}
